/* eslint-disable unicorn/filename-case -- kebab-case per docs/conventions/core.md: this file
   exports a hook, not a React component. Matches the same exemption on
   table-internals/use-row-keyboard-navigation.ts. */
import type { RowData } from '@tanstack/react-table';
import * as React from 'react';

import type { ParentRow } from './DimeNestedTable.types.js';

interface NestedRowKeyDownOptions<TParent extends RowData> {
  onToggleExpand: (row: ParentRow<TParent>) => void;
}

/** Expand/collapse keys only; ArrowUp/ArrowDown stay with useRowKeyboardNavigation. */
export function useNestedRowKeyDown<TParent extends RowData>({
  onToggleExpand,
}: NestedRowKeyDownOptions<TParent>) {
  return React.useCallback(
    (event: React.KeyboardEvent, row: ParentRow<TParent>) => {
      if (event.key === 'ArrowRight' && row.getCanExpand() && !row.getIsExpanded()) {
        event.preventDefault();
        onToggleExpand(row);
      } else if (event.key === 'ArrowLeft' && row.getIsExpanded()) {
        event.preventDefault();
        onToggleExpand(row);
      } else if ((event.key === 'Enter' || event.key === ' ') && row.getCanExpand()) {
        // The chevron is tabIndex -1, so the row must honour the keys a focused button would.
        event.preventDefault();
        onToggleExpand(row);
      }
    },
    [onToggleExpand],
  );
}
